import '../../../Osc.Common/Frontend/styles/main.scss';
import '../../../Osc.Common/Frontend/auth';
import '../styles/trumps.scss';